export const company = {
  statusId: 1,
  companyId: 20116,
  codigoUsuarioMaestro: 10075,
};

export const companyForm = {
  id: 20116,
};

export const paginationTopLimit = {
  limit: 9,
  topLimit: 999999999,
  limitPage: 1,
};
